<div>
  <div class="modal-header col-12">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg">
  </div>

  <div class="modal-body" style="padding: 30px 75px 0; justify-content: center;">
    <img title="Save changes icon" class="saveChangesIcon" width="68" height="70" src="assets/images/save_changes_popup_icon.svg">
    <h2 class="saveChangesTitle col-12">Are you sure?</h2>
    <h3 class="saveChangesMsg mt-4">You have unsaved changes in this order. Please save your changes by clicking 'Update Order' button at the bottom of the page.</h3>
  </div>

  <div class="modal-footer col-12" style="padding: 30px 75px; justify-content: center; flex-direction: column;">
    <button class="btn-green col-10" (click)="closeModal(false)">Back to update order</button>
    <button class="saveChangesCancel col-10" (click)="closeModal(true)">Exit this page</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/orders/edit/save-changes/save-changes.component.html